import React from "react";
import { Menu } from "lucide-react";
import FeedbackButton from '../common/FeedbackButton';
import { useLocation } from "react-router-dom";
import { usePremiumAccess } from "../../hooks/usePremiumAccess";
var HeaderMenuButton = function (_a) {
    var onClick = _a.onClick, showNoClientsTooltip = _a.showNoClientsTooltip, hasNotification = _a.hasNotification, showMenuButton = _a.showMenuButton;
    var location = useLocation();
    var isClientsPage = location.pathname === "/clients";
    // Lógica ajustada conforme solicitado:
    // - Se estiver no clientsPage e showMenuButton for false, exibe o botão.
    // - Se não estiver no clientsPage, exibe o botão.
    // - Se estiver no clientsPage e showMenuButton for true, oculta o botão.
    var showMenuButton_var = (!isClientsPage) || (isClientsPage && showMenuButton);
    // Hook para acesso premium/trial
    var _b = usePremiumAccess(), hasPremiumAccess = _b.hasPremiumAccess, isLoading = _b.isLoading;
    return (React.createElement("div", { className: "flex items-center gap-3" },
        !isLoading && hasPremiumAccess && React.createElement(FeedbackButton, null),
        showMenuButton_var && (React.createElement("button", { className: "p-2 bg-gray-800 rounded-full hover:bg-gray-700 transition flex items-center justify-center z-10 relative", title: showNoClientsTooltip ? "" : "Menu", onClick: onClick },
            React.createElement(Menu, { className: "text-white w-6 h-6" }),
            hasNotification && (React.createElement("span", { className: "absolute -top-1 -right-1 w-3 h-3 bg-red-700 rounded-full border-2 border-yellow shadow-lg animate-pulse z-10", title: "Notifica\u00E7\u00F5es pendentes" }))))));
};
export default HeaderMenuButton;
